import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Popover } from '@blueprintjs/core'

import styles from './iconMenu.module.scss'
import classNames from 'classnames'

class IconMenu extends Component {
    static propTypes = {
        content: PropTypes.node.isRequired,
        icon: PropTypes.node.isRequired,
        className: PropTypes.string,
    }

    render() {
        const { icon, content, className, disabled = false } = this.props

        return (
            <Popover
                minimal
                position="bottom-right"
                content={content}
                autoFocus={false}
                boundary="window"
                disabled={disabled}
            >
                <Button
                    minimal
                    className={classNames(styles.iconButton, {
                        [className]: className !== undefined,
                    })}
                    disabled={disabled}
                >
                    {icon}
                </Button>
            </Popover>
        )
    }
}

export default IconMenu
